import React, { useState, useEffect, Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebaseConfig';

// Public multi-page site
const PublicLayout = lazy(() => import('./pages/PublicLayout'));
const HomePage = lazy(() => import('./pages/HomePage'));
const ServiciosPage = lazy(() => import('./pages/ServiciosPage'));
const SolucionesPage = lazy(() => import('./pages/SolucionesPage'));
const PortafolioPage = lazy(() => import('./pages/PortafolioPage'));
const NosotrosPage = lazy(() => import('./pages/NosotrosPage'));
const ContactoPage = lazy(() => import('./pages/ContactoPage'));
const DrevoxSkyInterface = lazy(() => import('./components/DrevoxSkyInterface'));
import { PublicProvider } from './context/PublicContext';

// Internal / admin
const LoginAdmin = lazy(() => import('./components/LoginAdmin'));
const InternalLayout = lazy(() => import('./components/InternalLayout'));
const SolidarityAward = lazy(() => import('./pages/SolidarityAward'));
const KrownLinks = lazy(() => import('./pages/KrownLinks'));
const MarketingSAPage = lazy(() => import('./pages/MarketingSAPage'));
const BlogListPage = lazy(() => import('./pages/BlogListPage'));
const BlogPostPage = lazy(() => import('./pages/BlogPostPage'));



function App() {
  const [user, setUser] = useState(null);
  const [checkingAuth, setCheckingAuth] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setCheckingAuth(false);
    });
    return () => unsubscribe();
  }, []);

  if (checkingAuth) return (
    <div style={{ background: '#0a0f0a', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#00ff41', fontSize: '0.9rem' }}>Iniciando...</div>
    </div>
  );

  const LoadingFallback = (
    <div style={{ background: '#0a0f0a', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#00ff41', fontSize: '0.9rem' }}>Cargando...</div>
    </div>
  );

  return (
    <Router>
      <Suspense fallback={LoadingFallback}>
        <Routes>
          {/* ── Sitio público (multi-página) ── */}
          <Route element={<PublicProvider><PublicLayout /></PublicProvider>}>
            <Route path="/" element={<HomePage />} />
            <Route path="/servicios" element={<ServiciosPage />} />
            <Route path="/soluciones" element={<SolucionesPage />} />
            <Route path="/portafolio" element={<PortafolioPage />} />
            <Route path="/nosotros" element={<NosotrosPage />} />
            <Route path="/contacto" element={<ContactoPage />} />
            <Route path="/blog" element={<BlogListPage />} />
            <Route path="/blog/:slug" element={<BlogPostPage />} />
            <Route path="/sky" element={<DrevoxSkyInterface />} />
          </Route>

          {/* ── Landing Premio Solidario ── */}
          <Route path="/beneficio-digital" element={<SolidarityAward />} />

          {/* ── Admin del proyecto raíz ── */}
          <Route path="/admin" element={<LoginAdmin />} />
          <Route path="/panel" element={<InternalLayout />} />

          {/* ── Otras páginas ── */}
          <Route path="/krown" element={<KrownLinks />} />
          <Route path="/MarketingSA" element={<MarketingSAPage />} />

        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
